import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgEmpty = ({ title, titleId, ...props }) => /* @__PURE__ */ _jsxs("svg", {
	width: 201,
	height: 200,
	viewBox: "0 0 201 200",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	"aria-labelledby": titleId,
	...props,
	children: [
		title ? /* @__PURE__ */ _jsx("title", {
			id: titleId,
			children: title
		}) : null,
		/* @__PURE__ */ _jsx("path", {
			d: "M186.854 63.7417V136.042H52.5822V170.784H200V63.7417H186.854Z",
			fill: "#D6DADC"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M172.3 46.8403H24.8826V153.883H172.3V46.8403Z",
			fill: "white"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M39.9061 29V46.8404H172.3V136.042H187.324V29H39.9061Z",
			fill: "#1952B3"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M38.4977 53.4131H34.7418V57.169H38.4977V53.4131Z",
			fill: "#FF5100"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M45.0706 53.4131H41.3147V57.169H45.0706V53.4131Z",
			fill: "#FF5100"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M51.6433 53.4131H47.8875V57.169H51.6433V53.4131Z",
			fill: "#FF5100"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M124.883 75.9482H40.3756V104.117H124.883V75.9482Z",
			fill: "#F4F5F6"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M156.338 75.9482H130.986V137.92H156.338V75.9482Z",
			fill: "#F4F5F6"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M124.883 109.751H40.3756V137.92H124.883V109.751Z",
			fill: "#F4F5F6"
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M176.526 44.0234V157.638H41.3145V155.761H22.5352L22.5352 45.9014H126.291V44.0234H176.526ZM26.291 152.005V64.6807H163.38V60.9248H26.291V49.6572H126.291V51.5352H169.014V150.127H41.3145V152.005H26.291Z",
			fill: "black"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M9.50359 101.301L7.51174 103.292L14.1512 109.932L16.1431 107.94L9.50359 101.301Z",
			fill: "#232729"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M16.0764 140.026L14.0845 138.034L7.445 144.674L9.43685 146.666L16.0764 140.026Z",
			fill: "#232729"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M2.46261e-07 122.072L0 124.889L10.3286 124.889L10.3286 122.072L2.46261e-07 122.072Z",
			fill: "#232729"
		})
	]
});
export default SvgEmpty;
